module.exports = __webpack_public_path__ + "img/photo.9eef032e.png";